import { render, staticRenderFns } from "./Budget.vue?vue&type=template&id=4d4a830a"
import script from "./Budget.vue?vue&type=script&lang=js"
export * from "./Budget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports